<template lang="pug">
v-app(v-if="loading")
  v-container(fill-height)
    v-progress-circular.ma-auto(
      :width="10"
      color="primary"
      :size="125"
      indeterminate
    )
vue-extend-layouts(v-else)

</template>
<script>
import VueExtendLayouts from 'vue-extend-layout';
import {  mapGetters } from 'vuex';

export default {
  name: 'App',
  components: { VueExtendLayouts },
  data() {
    return {
      loading: true,
    };
  },

  computed:{
    ...mapGetters({
      user:'auth/getUser',
    }),
  },

  async created() {
    setTimeout(async () => {
      if (this.$route.name === 'auth-code') {
        this.loading = false;
        return;
      }

      try {
        await this.$store.dispatch('auth/init');
      } catch {
        this.$router.push(`/login?redirect=${this.$route.path}`);
      } finally {
        this.loading = false;
      }
    }, 400);
  },
};
</script>
<style lang="scss" src="@/styles/index.scss"></style>
